import { useState, useEffect } from 'react';
import { Alert, Linking } from 'react-native';

import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

import { checkCameraPermission } from '../Components/PermissionsChecker';
import { PaymentScreenTypes, PaymentTypes } from '../Utils/PaymentTypes';
import { VoucherCodeErrorTypes } from '../Utils/VoucherCodeErrorTypes';

const {
  VOUCHER_INTIIAL_STATE,
  VOUCHER_SCAN_QR_STATE,
  VOUVHER_TOP_UP_LOADING,
  VOUCHER_TOP_UP_SUCCESS,
  VOUCHER_TOP_UP_ERROR,
} = PaymentScreenTypes;

const useVoucherTopup = ({ type, setStatus, onPressConfirmVoucherCode, setError }) => {
  const [voucherTopupNumber, setVoucherTopupNumber] = useState('');

  const [isValidVoucherTopupNumber, setIsValidVoucherTopupNumber] = useState(false);
  const [shouldScanVoucherCode, setShouldScanVoucherCode] = useState(false);

  const [isTwoBtnVoucherError, setIsTwoBtnVoucherError] = useState(false);
  const [voucherAmount, setVoucherAmount] = useState(0);

  const onRetryAgainPress = () => {
    setVoucherTopupNumber('');
    setIsValidVoucherTopupNumber(false);
    setStatus(VOUCHER_INTIIAL_STATE);
  };

  const onCodeConfirm = () => {
    setStatus(VOUVHER_TOP_UP_LOADING);
    onPressConfirmVoucherCode(voucherTopupNumber)
      .then(data => {
        setVoucherAmount(data);
        setStatus(VOUCHER_TOP_UP_SUCCESS);
      })
      .catch(_error => {
        setIsTwoBtnVoucherError(_error.cause === VoucherCodeErrorTypes.NON_EXISTENT_CODE);
        setStatus(VOUCHER_TOP_UP_ERROR);
        setError({
          name: _error?.name,
          message: _error?.message,
          icon: _error?.icon,
        });
      });
  };

  const onPermissionBlocked = () => {
    const appSettingPermissionAlert = () =>
      Alert.alert(
        ContentManager.translate('voucher_camera_permission_title'),
        ContentManager.translate('voucher_camera_permission_description'),
        [
          {
            text: ContentManager.translate('voucher_camera_permission_cancel_btn_text'),
          },
          {
            text: ContentManager.translate('voucher_camera_permission_app_setting_btn_text'),
            onPress: Linking.openSettings,
          },
        ],
      );
    setTimeout(() => {
      appSettingPermissionAlert();
    }, 1);
  };

  const onCameraPressed = async () => {
    checkCameraPermission(() => {
      setShouldScanVoucherCode(true);
    }, onPermissionBlocked);
  };

  const onQRRead = data => {
    setVoucherTopupNumber(data);
    setShouldScanVoucherCode(false);
  };

  const onCancelVoucherQRScanner = () => {
    setShouldScanVoucherCode(false);
  };

  useEffect(() => {
    const { VOUCHER_TOP_UP } = PaymentTypes;

    if (type === VOUCHER_TOP_UP) {
      if (shouldScanVoucherCode) {
        setStatus(VOUCHER_SCAN_QR_STATE);
      } else {
        setStatus(VOUCHER_INTIIAL_STATE);
      }
    }
  }, [type, shouldScanVoucherCode]);

  return {
    voucherTopupNumber,
    setVoucherTopupNumber,
    onCodeConfirm,
    isTwoBtnVoucherError,
    onRetryAgainPress,
    voucherAmount,
    isValidVoucherTopupNumber,
    setIsValidVoucherTopupNumber,
    shouldScanVoucherCode,
    onQRRead,
    onCameraPressed,
    onCancelVoucherQRScanner,
    onPermissionBlocked,
  };
};

export default useVoucherTopup;
